var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M19.119 10.686c0 4.44-3.633 8.04-8.115 8.04-4.481 0-8.113-3.6-8.113-8.04 0-4.44 3.632-8.04 8.113-8.04 4.482 0 8.115 3.6 8.115 8.04",
    transform: "translate(.394 .828)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M3.931 8.812v7.744H2.17C.971 16.556 0 15.594 0 14.406v-3.445c0-1.187.971-2.15 2.169-2.15h1.762zM18.254 8.768v7.745h1.762c1.198 0 2.169-.962 2.169-2.15v-3.446c0-1.187-.971-2.149-2.17-2.149h-1.761z",
    transform: "translate(.394 .828)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334599",
    d: "M20.102 8.905H18.84c0-4.22-3.466-7.656-7.726-7.656S3.39 4.684 3.39 8.905H2.128C2.128 3.995 6.159 0 11.115 0c4.955 0 8.987 3.995 8.987 8.905M10.773 21.17c-4.99 0-9.05-4.023-9.05-8.967h1.1c0 4.344 3.566 7.877 7.95 7.877v1.09z",
    transform: "translate(.394 .828)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0AA8F0",
    d: "M12.346 20.625c0 .861-.705 1.559-1.573 1.559-.869 0-1.574-.698-1.574-1.559s.705-1.559 1.574-1.559c.868 0 1.573.698 1.573 1.559",
    transform: "translate(.394 .828)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.c44277deef898fb0e27d6df78e22ff31.svg";
export { ForwardRef as ReactComponent };